/**
 * useStreak — exposes the user's current study streak from the dashboard query.
 *
 * Reuses the existing `['user-dashboard', certCode]` react-query key so the
 * sidebar's streak pill is deduped/cached together with the Dashboard page.
 *
 * Returns 0 while loading, on error, or when no data is available — callers
 * can treat it as "unknown" and render the pill at a neutral value.
 */
import { useQuery } from '@tanstack/react-query';
import { fetchUserDashboard } from '../api/admin';
import { useCertStore } from '../stores/certStore';
import type { UserDashboardData } from '../types/admin';

export function useStreak(): number {
  const certCode = useCertStore((s) => s.certCode);
  const { data } = useQuery<UserDashboardData>({
    queryKey: ['user-dashboard', certCode],
    queryFn: () => fetchUserDashboard(certCode),
    staleTime: 60_000,
  });
  return data?.overview?.current_streak ?? 0;
}
